module.exports = __webpack_public_path__ + "img/five_bg.9c8cc5e8.jpg";